export const BLOG_POSTS = [
  {
    slug: 'ats-resume-guide',
    title: 'ATS Resume Guide: How Applicant Tracking Systems Read Your CV',
    excerpt:
      'Learn how ATS software parses resumes, which formats pass screening, and how to structure sections recruiters actually see.',
    category: 'Resume',
    date: '2026-05-10',
    relatedTool: 'resume-builder',
  },
  {
    slug: 'resume-mistakes-to-avoid',
    title: '15 Resume Mistakes That Cost You Interviews in 2026',
    excerpt:
      'From graphics-heavy templates to missing keywords — fix these common errors before you apply.',
    category: 'Resume',
    date: '2026-05-08',
    relatedTool: 'resume-builder',
  },
  {
    slug: 'static-vs-dynamic-qr-codes',
    title: 'Static vs Dynamic QR Codes: Which Should Your Business Use?',
    excerpt:
      'Compare permanence, analytics, cost, and use cases for marketing, menus, and WiFi sharing.',
    category: 'QR',
    date: '2026-05-12',
    relatedTool: 'qr-code-generator',
  },
  {
    slug: 'restaurant-qr-menu-ideas',
    title: 'Restaurant QR Menu Ideas That Actually Work for Guests',
    excerpt:
      'Placement, sizing, accessibility, and design tips for QR menus customers will scan.',
    category: 'QR',
    date: '2026-05-06',
    relatedTool: 'qr-code-generator',
  },
  {
    slug: 'us-to-eu-shoe-size-conversion',
    title: 'US to EU Shoe Size Conversion Chart (Men, Women & Kids)',
    excerpt:
      'Official-style conversion tables plus how Nike, Adidas, and Zara sizing differ from standard charts.',
    category: 'Sizing',
    date: '2026-05-14',
    relatedTool: 'clothing-shoe-size-converter',
  },
  {
    slug: 'how-to-measure-feet-for-shoe-size',
    title: 'How to Measure Your Feet for Accurate Shoe Size',
    excerpt:
      'Step-by-step CM and inch measurement, width notes, and when to size up for running shoes.',
    category: 'Sizing',
    date: '2026-05-04',
    relatedTool: 'clothing-shoe-size-converter',
  },
];

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}
